import {useAuthStore} from '@frontend/stores'
import {useEffect} from 'react'

// Выход из аккаунта
export default function LogoutPage() {

    const logout = useAuthStore(
        state => state.logout
    )

    useEffect(() => {
        logout('private')
    }, [])

    return null
}
